import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { getAuth } from 'firebase/auth'

import authenticationService from '@/services/authentication/authentication'

export async function refreshIdTokenInterceptor(response: AxiosResponse) {
  const shouldRefreshIdToken = !!response.headers['x-refresh-id-token']
  if (shouldRefreshIdToken) await authenticationService.refreshIdToken()

  return response
}

export async function attachAuthorizationHeaderInterceptor(config: AxiosRequestConfig) {
  if (getAuth().currentUser) {
    const authToken = await getAuthorizationToken()
    config.headers = { ...config.headers, Authorization: authToken }
  }

  return config
}

export async function logResponseInterceptor(response: AxiosResponse) {
  const {
    config: { data, method = 'UNKNOWN', url },
    status,
  } = response

  if (status >= 400) console.error(`🌎 [${method.toUpperCase()}] ${url} - ${status}`, data)
  else console.log(`🌎 [${method.toUpperCase()}] ${url} - ${status}`)

  return response
}

async function getAuthorizationToken() {
  const idToken = await getAuth().currentUser?.getIdToken()

  return `Bearer ${idToken}`
}
